import React from 'react';
import ReactDOM from 'react-dom';

const renderDom = (content, node = <div />) => {
  ReactDOM.render(content, node);
};

export default renderDom;
